















import { defineComponent, useContext, onMounted } from "@nuxtjs/composition-api";
import { SfHeading, SfButton } from "@storefront-ui/vue";
import { useGtm } from "~/composables";
import { usePageStore } from '~/stores/page';
import { assign } from "lodash-es";

export default defineComponent({
  name: "ContactSuccess",
  components: {
    SfHeading,
    SfButton,
  },
  setup() {
    const pageStore = usePageStore();
    const { eventPageLoad } = useGtm();
    const { app: { i18n } } = useContext();

    pageStore.$patch((state) => {
      state.pageData = assign(state.pageData, {
        pageName: i18n.t('Thank you for your message'),
        pageTitle: i18n.t('Thank you for your message'),
        pageCategory: i18n.t('Thank you for your message'),
        breadCrumbs: [i18n.t('Home'), i18n.t('Thank you for your message')]
      });
    });
    onMounted(() => {
      eventPageLoad();
    });

    return {};
  },
});
